import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disagree-message" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Deze melding wordt binnen 5 dagen automatisch gesloten. Mocht u het niet eens zijn met de afhandeling van uw servicemelding, dan kunt u dit via onderstaande knop, binnen 5 dagen, aangeven.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Geeft u hieronder zo duidelijk mogelijk aan waarom u het niet eens bent met de oplossing.", -1)

import { ref } from 'vue'
import { UserOutlined } from '@ant-design/icons-vue'
import Filelist from '@/components/Filelist.vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { NewComment } from '../../types/NewServiceComment'
import TextEditor from '@/components/TextEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DisagreeMessage',
  props: {
  modelId: String
},
  emits: ['userDisagreed'],
  setup(__props, { emit }) {

const props = __props





const showDisagreeModal = ref(false)

const newComment = ref<NewComment>({
  body: null,
  shared: {
    client: true,
    solver: true
  },
  media: []
})

function toggleDisagreeModal () : void {
  newComment.value = {
    body: null,
    shared: { client: true, solver: true },
    media: []
  }

  showDisagreeModal.value = !showDisagreeModal.value
}

function storeDisagreeComment () : void {
  axios.post(process.env.VUE_APP_API_URL + '/issues/' + props.modelId + '/rejected', newComment.value).then(() => {
    emit('userDisagreed')
    toggleDisagreeModal()

    notification.success({
      message: 'Wij hebben uw bericht ontvangen.',
      description: 'Wij hebben uw bericht succesvol ontvangen. Wij komen zo spoedig mogelijk bij u terug.',
      duration: 5
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_button, { onClick: toggleDisagreeModal }, {
      default: _withCtx(() => [
        _createTextVNode("Oneens met oplossing")
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "U bent het oneens met de oplossing",
      visible: showDisagreeModal.value,
      "ok-text": "Versturen",
      onOk: storeDisagreeComment,
      "cancel-text": "Annuleren",
      onCancel: toggleDisagreeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(TextEditor, {
                  onContentChange: _cache[0] || (_cache[0] = ($event: any) => (newComment.value.body = $event))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})